function getFieldNameForPrintAndSign(
  format: string,
  mode: string
): string | string[] {
  return (
    [
      {
        format: 'pdf',
        mode: 'svod-one-year',
        name: 'req_file_print_latest_pdf',
      },
      {
        format: 'xlsx',
        mode: 'svod-one-year',
        name: 'req_file_print_latest_xlsx',
      },
      {
        format: 'pdf+xlsx',
        mode: 'svod-one-year',
        name: ['req_file_print_latest_pdf', 'req_file_print_latest_xlsx'],
      },
      {
        format: 'zip',
        mode: 'svod-one-year',
        name: 'req_file_signed_one_year',
      },
      {
        format: 'pdf',
        mode: 'extract',
        name: 'req_file_print_latest_pdf',
      },
      {
        format: 'xlsx',
        mode: 'extract',
        name: 'req_file_print_latest_xlsx',
      },
      {
        format: 'zip',
        mode: 'extract',
        name: 'req_file_signed_archive',
      },
      {
        format: 'pdf',
        mode: 'extract',
        name: 'req_file_print_latest_pdf',
      },
      {
        format: 'xlsx',
        mode: 'extract-full',
        name: 'req_file_print_latest_xlsx',
      },
      {
        format: 'zip',
        mode: 'extract-full',
        name: 'req_file_signed_archive',
      },
      {
        format: 'pdf',
        mode: 'extract-free',
        name: 'req_file_print_latest_pdf',
      },
      {
        format: 'xlsx',
        mode: 'extract-free',
        name: 'req_file_print_latest_xlsx',
      },
      {
        format: 'zip',
        mode: 'extract-free',
        name: 'req_file_signed_archive',
      },
      {
        format: 'pdf',
        mode: 'extract-npzu',
        name: 'req_file_print_latest_pdf',
      },
      {
        format: 'xlsx',
        mode: 'extract-npzu',
        name: 'req_file_print_latest_xlsx',
      },
      {
        format: 'zip',
        mode: 'extract-npzu',
        name: 'req_file_signed_archive',
      },
    ].find(el => el.format === format && el.mode === mode)?.name || ''
  );
}

export default getFieldNameForPrintAndSign;
